import MlseLogoWhite from "@icons/MlseLogoWhite.svg";

import { LogoWrapper, MainLogoWrapper } from "./style";

interface LogoLoginPageProps {
  isDesktop: boolean;
}

const LogoLoginPage = (props: LogoLoginPageProps) => {
  const { isDesktop } = props;
  return (
    <MainLogoWrapper isDesktop={isDesktop}>
      <LogoWrapper>
        <img style={{ width: "100%" }} src={MlseLogoWhite} alt="logo" />
      </LogoWrapper>
    </MainLogoWrapper>
  );
};

export default LogoLoginPage;
